import {ApartmentViewerService} from "features/apartmentViewer/services/ApartmentViewerService/service";

export class ApartmentViewerQueryMethods {
    public static getApartmentData = async (stageId: string, objectId: string) => {
        const response = await ApartmentViewerService.getApartmentData(stageId, objectId);

        return response;
    }
}
